import api from './axios';

// 3개월이상 비밀번호 미변경 조회
export const threeMonthCheck = async (params) => {
  const response = await api.get('/knouUser/mypage/threeMonthCheck',{params: params});
  return response.data;
};

// 가상체험관 메인 - 슬라이드용 콘텐츠
export const getMainContentList = async () => {
  const response = await api.get('/knouVLab/getMainContentList');
  return response.data;
};

// 가상체험관 신청 - 콘텐츠 리스트
export const getContentList = async (params) => {
  const response = await api.get('/knouVLab/getContentList', { params });
  return response.data;
};

// 가상체험관 메인 - 공지사항 조회 (NoticeController의 getNotice)
export const getNotice = async (params) => {
  // params: { page, pageSize, keyword, ... }
  const response = await api.post('/knouVLab/getNotice', params)
  return response.data
}

// 통합검색 API 추가
// 요약 (GET /knouUser/search/summary?keyword=...)
export const getSearchSummary = async ({ keyword }) => {
  const response = await api.get('/knouUser/search/summary', {
    params: { keyword },
  });
  return response.data; // SearchSummaryResponse 그대로
};

// 상세 (GET /knouUser/search/detail?keyword=&tab=&page=&pageSize=...)
export const getSearchDetail = async ({ keyword, tab, page = 1, pageSize = 10 }) => {
  const response = await api.get('/knouUser/search/detail', {
    params: { keyword, tab, page, pageSize },
  });
  return response.data; // SearchDetailResponse 그대로
};
